<template>
  <div
    class="o-alert u-padding-bottom-xlarge-xs-down u-margin-top-small o-alert--danger u-margin-0"
  >
    <i class="icofont-ui-lock"></i>
    {{ $t("projectDetail.isLockedDescription") }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  props: {
    battery: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
